export const navigation = {
  categories: ["Start", "Nasza oferta", "O nas", "Realizacje", "Kontakt"],
};
